import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const deleteSavedOrders = async ({ callerId, orderIds }: { callerId: string; orderIds: string[] }): Promise<boolean> => {
  const response = await queryExecute({
    query: graphql(`
      query DeleteSavedOrders($callerId: String!, $orderIds: [String!]!) {
        deleteSavedOrders(callerId: $callerId, orderIds: $orderIds)
      }
    `),
    variables: {
      callerId,
      orderIds,
    },
  });

  return response.data?.deleteSavedOrders;
};
